import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const usePDPRedirectDoubleQuery = () => {
  const { pathname, search: queryParamsString } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (queryParamsString) {
      const queryParamsStringWithoutFirstQuestionMark = queryParamsString.replace(
        '?',
        ''
      );

      if (queryParamsStringWithoutFirstQuestionMark.includes('?')) {
        const updatedQueryParamsString = queryParamsStringWithoutFirstQuestionMark.replace(
          '?',
          '&'
        );

        window.location.href = `${pathname}?${updatedQueryParamsString}`;
      }
    }
  }, [history, pathname, queryParamsString]);
};

export default usePDPRedirectDoubleQuery;
